import { BOX_TRUCK_DRIVER_CLAIMED_ERROR } from '@numeo/types-core'
import axios from 'axios'

export type BoxTruckSaveFailureReason = 'conflict' | 'claim_taken' | 'validation' | 'server' | 'network'

/** Shared bounded failure buckets for Box Truck profile saves. */
export const classifyBoxTruckSaveFailure = (error: unknown): BoxTruckSaveFailureReason => {
    if (!axios.isAxiosError(error) || !error.response) return 'network'
    const { status, data } = error.response
    const errorCode = typeof data === 'object' && data !== null && 'errorCode' in data && typeof data.errorCode === 'string' ? data.errorCode : undefined
    if (status === 409) return errorCode === BOX_TRUCK_DRIVER_CLAIMED_ERROR ? 'claim_taken' : 'conflict'
    if (status >= 400 && status < 500) return 'validation'
    return 'server'
}
